import {green, orange, purple, grey, blue, red} from "@material-ui/core/colors";

export const TRACKER_STATUS = {
  CONFIGURED: 1,
  ACTIVE: 2,
  IN_USE: 3,
  EXTRACTED: 4,
  MAINTENANCE: 5,
  NO_SIGNAL: 6,
  PROCESS_DISCARTED: 7
}

const TRACKING_STATUS_INFO  = {
  [TRACKER_STATUS.CONFIGURED]: {
    translation: "configured",
    iconColor: blue[600],
    iconClass: "trackingConfigured",
    warning: false,
    clickable: false,
    error: false
  },
  [TRACKER_STATUS.ACTIVE]: {
    translation: "active",
    iconColor: green[600],
    iconClass: "trackingActive",
    warning: false,
    clickable: true,
    error: false
  },
  [TRACKER_STATUS.IN_USE]: {
    translation: "in_use",
    iconColor: purple[600],
    iconClass: "trackingInUse",
    warning: false,
    clickable: false,
    error: false
  },
  [TRACKER_STATUS.EXTRACTED]: {
    translation: "retired",
    iconColor: red[600],
    iconClass: "trackingWarning",
    warning: true,
    clickable: false,
    error: false
  },
  [TRACKER_STATUS.MAINTENANCE]: {
    translation: "maintenance",
    iconColor: orange[500],
    iconClass: "trackingWarning",
    warning: true,
    clickable: false,
    error: false
  },
  [TRACKER_STATUS.NO_SIGNAL]: {
    translation: "no_signal",
    iconColor: orange[500],
    iconClass: "trackingNoSignal",
    warning: false,
    clickable: false,
    error: true
  },
  [TRACKER_STATUS.PROCESS_DISCARTED]: {
    translation: "process_discarted",
    iconColor: orange[500],
    iconClass: "trackingWarning",
    warning: true,
    clickable: true,
    error: false
  }
};

const DEFAULT_STATUS = {
  translation: "empty",
  iconColor: grey[700],
  iconClass: "trackingDisabled",
  warning: false,
  clickable: false,
    error: false
};

const getTrackingStatusInfo = (status, t) => {
  const config = TRACKING_STATUS_INFO[status] || DEFAULT_STATUS;
  return {
    ...config,
    text: t(`devices.tracking.config.status.${config.translation}`)
  };
};

export default
getTrackingStatusInfo;